import { restClient } from '@/Core'
import { userManager } from '@/Core/Managers'

/** Ship-вихід: відкликає refresh-токен на беку (`SPEC-014` §1.2, Р1). */
export const LOGOUT_URL = '/services/auth/logout'

const revoke = async (refreshToken: string): Promise<void> => {
    try {
        await restClient.post(LOGOUT_URL, {
            json: { refresh_token: refreshToken },
            headers: { 'Content-Type': 'application/json' },
        })
    } catch {
        // Вихід не залежить від відповіді: локальну сесію гасимо однаково,
        // а невідкликаний токен сам помре за годину (`ttl` refresh)
    }
}

/**
 * «Вихід»: відкликати refresh-токен на беку, потім вийти локально.
 *
 * Ядровий `userManager.logout()` бек не кличе взагалі — лише чистить стор, і
 * refresh-токен після виходу жив ще годину: будь-хто з копією `localStorage`
 * продовжував сесію (D-25).
 *
 * ⚠️ Якщо JWT на момент виходу вже прострочений, ядровий клієнт на 401 сам
 * оновлює токен і повторює запит — із **тим самим тілом**, тобто зі старим,
 * уже використаним refresh-токеном (він одноразовий). Новий токен, виданий
 * цим оновленням, лишився б живим. Тому після запиту звіряємо: токен
 * змінився — відкликаємо й новий.
 */
export const LogoutTask = async (): Promise<void> => {
    const sent = userManager.refreshToken

    if (sent) {
        await revoke(sent)

        const rotated = userManager.refreshToken

        if (rotated && rotated !== sent) {
            await revoke(rotated)
        }
    }

    userManager.logout()
}
